import React from "react";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
} from "@mui/material";

// 📊 Affichage des groupes par année et par mois
const GroupesParAnEtMois = ({ groupesParAn, groupesParMois }) => {

  // 🧩 Fonction générique pour rendre un tableau (année ou mois)
  const renderTable = (label, data, type) => (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        {label}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{type === "an" ? "Année" : "Mois"}</TableCell>
            <TableCell>Pays</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Nombre</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(data).flatMap(([periode, paysMap]) =>
            Object.entries(paysMap).flatMap(([pays, typeMap]) =>
              Object.entries(typeMap).map(([type, count]) => (
                <TableRow key={`${periode}-${pays}-${type}`}>
                  <TableCell>{periode}</TableCell>
                  <TableCell>{pays}</TableCell>
                  <TableCell>{type}</TableCell>
                  <TableCell>{count}</TableCell>
                </TableRow>
              ))
            )
          )}
        </TableBody>
      </Table>
    </Box>
  );

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      

      {renderTable("📅 Groupes par année et pays", groupesParAn, "an")}
      {renderTable("📆 Groupes par mois et pays", groupesParMois, "mois")}
    </Paper>
  );
};

export default GroupesParAnEtMois;
